<div class="withdraw-summary">
  <h2 class="ds-heading-2">{{ 'ACCOUNT.withdrawalV2.summary.' + title | translate }}</h2>

  <div class="withdraw-summary-box">
    <ng-container *ngFor="let summaryItem of summary; let first = first; let last = last">
      <div class="withdraw-summary-item" [ngClass]="{ first: first, last: last }">
        <div>
          <p class="ds-ui-2 ds-color-core-neutral-7">{{ summaryItem.title | translate }}</p>
          <h3 class="ds-heading-3 ds-color-core-neutral-10">{{ summaryItem.value }}</h3>
        </div>

        <div>
          <app-ds-icon
            name="dsEdit"
            [size]="'icon-size-3'"
            [color]="'var(--color-core-neutral-10)'"
            (click)="onOpenStep(summaryItem.step)"
          ></app-ds-icon>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div class="withdraw-next">
  <h2 class="ds-heading-2 ds-color-core-neutral-10">{{ 'ACCOUNT.withdrawalV2.summary.next.heading' | translate }}</h2>
  <ng-container *ngFor="let next of nextSteps">
    <div class="withdraw-next-item">
      <app-ds-rounded-icon variant="custom" [icon]="next.icon" [customColor]="'var(--' + next.color + ')'"></app-ds-rounded-icon>
      <div class="withdraw-next-content">
        <p class="ds-heading-3 ds-color-core-neutral-10">{{ 'ACCOUNT.withdrawalV2.summary.next.' + next.step + '.title' | translate }}</p>
        <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'ACCOUNT.withdrawalV2.summary.next.' + next.step + '.description' | translate }}</p>
      </div>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="showCallout && accountInvested">
  <app-ds-callout
    id="callout"
    variant="warning"
    [title]="(isPartial ? 'ACCOUNT.withdrawalV2.amount.warning.title' : 'ACCOUNT.withdrawalV2.summary.warning.title') | translate"
    [description]="
      (isPartial ? 'ACCOUNT.withdrawalV2.amount.warning.description' : 'ACCOUNT.withdrawalV2.summary.warning.description')
        | translate: { amount: minAmountText }
    "
  ></app-ds-callout>
</ng-container>

<div class="withdraw-buttons" [class.mobile-buttons]="isMobileApp" [ngStyle]="{ display: isMobileApp ? 'block' : 'flex' }">
  <app-ds-button [width]="isMobileApp ? 'full' : 'auto'" [isLoading]="isLoading" (clicked)="onContinue()">{{
    'ACCOUNT.withdrawalV2.buttons.submit' | translate
  }}</app-ds-button>
  <app-ds-button [width]="isMobileApp ? 'full' : 'auto'" variant="outline" (clicked)="onBack()">{{
    'ACCOUNT.withdrawalV2.buttons.previous' | translate
  }}</app-ds-button>
</div>
